import { Grid } from "@mui/material";
import ExplorerGrid, { useExplorerGrid } from "common/ExplorerGrid";
import { Can } from "context/permissionContenxt";
import PageNotFound from "pages/PageNotFound";
import useToolbarProps from "qubCommon/ExplorerToolbar/useToolbarProps";
import { TextInput } from "qubCommon/Inputs";

const ExpensesExplorer = () => {
  const { status, critParams, ...toolbarRest } = useToolbarProps({
    webPageKey: "Expenses-Expl",
    hideAddNew: true,
  });

  const { explParams, ...explorerRest } = useExplorerGrid({
    explorerDataKey: "Expenses-Expl",
    xlsxName: "Expenses",
    navUrl: "/expenses/{:id}",
    status,
  });

  return (
    <>
      <Can I="View" a="MHD_GovnrExpenses">
        <div
          style={{
            margin: 20,
            padding: 20,
            borderRadius: 8,
            backgroundColor: "#f3f3f3",
          }}
        >
          <ExplorerGrid
            explParams={explParams}
            title="Σύνοψη Δαπανών ΜΗΔ"
            breadcrumbs={[{ name: "Σύνοψη Δαπανών ΜΗΔ", path: "govnr/expenses" }]}
            autoRowHeights
            {...explorerRest}
            {...toolbarRest}
          >
            <Grid item xs={12} md={6} lg={4}>
              <TextInput
                id="Search"
                name="searchFieldValue"
                label="Αναζήτηση"
                placeholder="Αναζήτηση"
                defaultValue={critParams?.searchFieldValue ?? ""}
              />
            </Grid>
          </ExplorerGrid>
        </div>
      </Can>
      <Can not I="View" a="MHD_GovnrExpenses">
        <PageNotFound />
      </Can>
    </>
  );
};

export default ExpensesExplorer;
